// extracted by mini-css-extract-plugin
module.exports = {"listOfItems":"_2PqhyXjXQq-nAL2uWLJ6","item":"_13QgLNMlI7NLUbhvF9zrtC","dot":"_2g9R6rbtumEF6XV6VWfMvL"};